import { render, staticRenderFns } from "./listTarjaDialog.vue?vue&type=template&id=8b6d4d0a&"
import script from "./listTarjaDialog.vue?vue&type=script&lang=js&"
export * from "./listTarjaDialog.vue?vue&type=script&lang=js&"
import style0 from "./listTarjaDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports